import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from '@heroicons/react/24/solid';
import { useLanguage } from '../contexts/LanguageContext';

const EmergencyButton: React.FC = () => {
  const { translations } = useLanguage();

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end space-y-2">
      <div className="transform transition-transform duration-300 hover:scale-105">
        <a 
          href="tel:603319648" 
          className="flex items-center justify-center bg-coral text-white hover:bg-coral/90 py-2.5 px-4 rounded-full shadow-lg border-2 border-white animate-emergencyPulse"
          aria-label="Call emergency service"
        >
          <PhoneIcon className="w-5 h-5 mr-1.5" aria-hidden="true" />
          <span className="font-bold">603 31 96 48</span>
        </a>
      </div>
      <Link 
        to="/emergency" 
        className="text-xs bg-white text-coral px-3 py-1 rounded-full shadow-md hover:bg-gray-100 font-semibold"
      >
        {translations.nav.emergency}
      </Link>
    </div>
  );
};

export default EmergencyButton; 